import React from 'react';
import { View } from 'react-native';
import { createDrawerNavigator } from '@react-navigation/drawer';
import { Icon, DrawerHeaderFooter, Drawer as UIKittenDrawer } from '@ui-kitten/components';
import { SafeAreaView } from 'react-native-safe-area-context';
import { ProfileStack } from './profile.stack';
import { OrganizationStack } from './organization.stack';
import { SurveyStack } from './surveys/survey.stack';
import { HomeStack } from './home.stack';
import { useScreenDimensions } from '../utils/useScreenInfo';
import { CampaignStack } from './campaign.stack';
import { ThemeToggle } from './shared/theme.toggle';
import { BrandText } from '../components/brandText';
import { CurrentUser } from '../App';
import { TakeSurveyScreen, TakePollScreen } from '../screens';
import { MainStack, MainTabNavigator } from './main.stack';
import { DashboardStack } from './dashboard.stack';
import { PollStack } from './surveys/poll.stack';

const Drawer = createDrawerNavigator();

export const DrawerNavigator = ({ userAuthorized, user }: { userAuthorized: boolean; user: CurrentUser }): React.ReactElement => {
    // console.log('RootNavigator userAuthorized', userAuthorized);
    const { isLargeScreenOrLarger } = useScreenDimensions();
    const drawerData = userAuthorized ? (user.product_plan.title === 'Premium' ? authPremiumPlanDrawerData : authBasicPlanDrawerData) : publicDrawerData;
    const drawerType: 'front' | 'back' | 'slide' | 'permanent' = undefined; // (userAuthorized && isLargeScreenOrLarger) ? 'permanent' : 'front';

    return (
        <Drawer.Navigator
            drawerContent={(props) => <DrawerContent drawerData={drawerData} userAuthorized={userAuthorized} {...props} />}
            drawerType={drawerType}
            initialRouteName='Home'
        >
            {userAuthorized ? (
                <>
                    <Drawer.Screen name='Home' component={DashboardStack} />
                    <Drawer.Screen name='Surveys' component={SurveyStack} />
                    <Drawer.Screen name='Polls' component={PollStack} />
                    <Drawer.Screen name='Campaigns' component={CampaignStack} />
                    <Drawer.Screen name='Account' component={ProfileStack} />
                    {user.product_plan.title === 'Premium' ? (
                        <Drawer.Screen name='Groups' component={OrganizationStack} />
                    ): undefined}
                </>
                ) : (
                <Drawer.Screen name='Home' component={HomeStack} />
            )}
            <Drawer.Screen name='TakeSurvey' component={TakeSurveyScreen} />
            <Drawer.Screen name='TakePoll' component={TakePollScreen} />
        </Drawer.Navigator>
    );
};


const DrawerContent = ({ navigation, drawerData, userAuthorized }): React.ReactElement => {

    const onRouteSelect = (index: number) => {
        // console.log({ navigation, state, drawerData, event });
        navigation.navigate(drawerData[index].route, drawerData[index].params);
    };

    return (
        <SafeAreaView style={{ flex: 1 }}>
            <UIKittenDrawer
                header={() => <Header userAuthorized={userAuthorized} />}
                data={drawerData}
                footer={() => <Footer />}
                onSelect={onRouteSelect}
            />
        </SafeAreaView>
    )
};

const Header = ({ userAuthorized }) => {
    console.log('userAuthorized', userAuthorized);
    if (false && userAuthorized) {        
        return (
            <DrawerHeaderFooter
                // title='John Doe'
                // description='React Native Developer'
                // accessory={() => <Avatar source={{ uri: 'https://pbs.twimg.com/profile_images/952545910990495744/b59hSXUd_400x400.jpg' }} size={'giant'} />}
            />
        )
    }
    else {
        return (
            // <DrawerHeaderFooter
            //     title='Poall'
            //     description=' '
            //     accessory={() => <Avatar source={poallImages.poall_logo} size={'giant'} />}
            // />
            <View style={{ paddingLeft: 20, paddingTop: 8, paddingBottom: 15 }}>
                <BrandText status='primary' category='h3'>poall</BrandText>
            </View>
        );
    }
};

const Footer = () => (
    <>
        <ThemeToggle />
    </>
);



const HomeIcon = (style) => (
    <Icon {...style} name='home-outline' />
);



const SettingsIcon = (style) => (
    <Icon {...style} name='settings-outline' />
);

const CampaignIcon = (style) => (
    <Icon {...style} name='award-outline' />
);

const SurveyIcon = (style) => (
    <Icon {...style} name='clipboard-outline' />
);

const PollIcon = (style) => (
    <Icon {...style} name='bar-chart-outline' />
);

const UsersIcon = (style: any) => (
    <Icon {...style} name='people-outline' />
);


const authBasicPlanDrawerData = [
    {
        title: 'Home',
        route: 'Home',
        params: {
            screen: 'Dash'
        },
        icon: HomeIcon,
    },
    // {
    //     title: 'Campaigns',
    //     route: 'Campaigns',
    //     params: {
    //         screen: 'Campaigns'
    //     },
    //     icon: CampaignIcon,
    // },
    {
        title: 'Surveys',
        route: 'Surveys',
        params: {
            screen: 'All'
        },
        icon: SurveyIcon,
    },
    {
        title: 'Polls',
        route: 'Polls',
        params: {
            screen: 'All'
        },
        icon: PollIcon,
    },
    {
        title: 'Account',
        route: 'Account',
        icon: SettingsIcon,
    }
];

const authPremiumPlanDrawerData = [
    {
        title: 'Home',
        route: 'Home',
        params: {
            screen: 'Dash'
        },
        icon: HomeIcon,
    },
    {
        title: 'Organization',
        route: 'Groups',
        params: {
            screen: 'Organization'
        },
        icon: UsersIcon,
    },
    {
        title: 'Campaigns',
        route: 'Campaigns',
        params: {
            screen: 'Campaigns'
        },
        icon: CampaignIcon,
    },
    {
        title: 'Surveys',
        route: 'Surveys',
        params: {
            screen: 'All'
        },
        icon: SurveyIcon,
    },
    {
        title: 'Polls',
        route: 'Polls',
        params: {
            screen: 'All'
        },
        icon: SurveyIcon,
    },
    {
        title: 'Account',
        route: 'Account',
        icon: SettingsIcon,
    }
];


const publicDrawerData = [
    {
        title: 'Home',
        route: 'Home',
        icon: HomeIcon,
    },
    {
        title: 'Account',
        route: 'Account',
        icon: SettingsIcon,
    }
];
